/* eslint-disable react-hooks/exhaustive-deps */

import { Button, Card, Loading, SingleDatePicker, Slider, Tooltip } from '@sede-enterprise/shell-ds-react-framework'
import { InfoCircle } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components'
import React, { useEffect, useState } from 'react'
import momentGenerateConfig from 'rc-picker/lib/generate/moment'
import moment from "moment";
import { handleDateChange } from '../../util/handleDateChange';
import ReactSpeedometer from 'react-d3-speedometer';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { convertmmToMils, mmOrInch, mmOrMiles, round } from '../../util/helperFunctions';
import { helperTexts } from '../../util/helperTexts';
import { submitForm, updateThreshold } from './utils/alertTabUtils';
import useSensorAlerts from './hooks/useSensorAlerts';

const helpContents = helperTexts.sensorAlertsTab;

const format = "yyyy-MM-DD";


const initialAlertData = [
    {
        category: 'Predicted corrosion rate alerts',
        id: 'predicted-1'
    },
    {
        category: 'Measured corrosion rate alerts',
        id: 'measured-2'
    }
]


const SensorAlertsTab = (props) => {
    const {
        site,
        units,
        isRealSensor,
        start,
        end,
        sensorID,
        sensorAlertThreshold,
        setAlertThresholdUpdate,
        alertThresholdUpdate
    } = props;

    const [startDate, setStartDate] = useState(start);
    const [inValidStartDate, setInValidStartDate] = useState(null);
    const [startErrorText, setStartErrorText] = useState(null);

    const [endDate, setEndDate] = useState(end);
    const [inValidEndDate, setInValidEndDate] = useState(null);
    const [endErrorText, setEndErrorText] = useState(null);
    const [alertThreshold, setAlertThershold] = useState(units ? +convertmmToMils(sensorAlertThreshold) : +sensorAlertThreshold);

    const corrosionAlertData = initialAlertData;

    const { alertReport, loading, setAlertReport, setLoading } = useSensorAlerts(
        sensorID,
        moment(start).format("YYYY-MM-DD"),
        moment(end).format("YYYY-MM-DD"),
        alertThresholdUpdate
    );

    useEffect(() => {
        setAlertThershold(units
            ? +convertmmToMils(sensorAlertThreshold)
            : +sensorAlertThreshold
        )
    }, [units, sensorAlertThreshold])




    // const handleUpdateThreshold = () => {
    //     updateThreshold(sensorID, alertThreshold, units, setAlertReport, setLoading, setAlertThresholdUpdate);
    // };

    useEffect(() => {
        if (moment(startDate).toDate().toDateString() !== "Invalid Date" && moment(endDate).toDate().toDateString() !== "Invalid Date") {
            submitForm(sensorID, startDate, endDate, setAlertReport, setLoading);
        }
    }, [startDate, endDate]);

    const loadingScreen = <div className='loading-container' role='status'>
        <Loading />
    </div>

    let alertRepData = { title: null, category: null, statusTitle: null, alertCount: null, longestDuration: null, cumulativeDuration: null, wallThicknessLoss: null, maxCorrosionRate: null };
    const filteredCorrosionAlertData = corrosionAlertData.filter(ele => isRealSensor || ele.category !== 'Measured corrosion rate alerts');
    const alertPanels = alertReport ? filteredCorrosionAlertData.map(ele => {
        if (alertReport) {
            alertRepData = (ele.category === 'Predicted corrosion rate alerts' || ele.category === 'Predicted Corrosion Rate') ?
                {
                    title: "Predicted Corrosion Rate Alerts",
                    category: "Predicted Corrosion Rate",
                    statusTitle: "Average Predicted Corrosion Rate",
                    alertCount: alertReport.predictedAlertsCount,
                    longestDuration: alertReport.longestPredictedDurationInDays,
                    cumulativeDuration: alertReport.predictedCumulativeDurationInDays,
                    wallThicknessLoss: alertReport.predictedWallThicknessLoss,
                    maxCorrosionRate: alertReport.predictedMaxCR,
                }
                : {
                    title: "Measured Corrosion Rate Alerts",
                    category: "Measured Corrosion Rate",
                    statusTitle: "Average Measured Corrosion Rate",
                    alertCount: alertReport.measuredAlertsCount,
                    longestDuration: alertReport.longestMeasuredDurationInDays,
                    cumulativeDuration: alertReport.measuredCumulativeDurationInDays,
                    wallThicknessLoss: alertReport.measuredWallThicknessLoss,
                    maxCorrosionRate: alertReport.measuredMaxCR,
                };

            const isActualALert = ((ele.category === 'Measured corrosion rate alerts' || ele.category === 'Measured Corrosion Rate'))
            const avgCR = isActualALert ? alertReport.measuredAvgCR : alertReport.predictedAvgCR;
            const displayedAlertavgCR = units
                ? convertmmToMils(avgCR)
                : avgCR
            let speedmeterValue = 825

            if (displayedAlertavgCR < alertThreshold) {
                speedmeterValue = 500
                if (displayedAlertavgCR < (alertThreshold / 2)) {
                    speedmeterValue = 180
                }
            }

            return (<Card bodyPadding={false} className='alert-details-card' id="sensor-alerts-tab-id-1">
                <div className='alert-details-card-header' id="sensor-alerts-tab-id-2">
                    <h4 id="sensor-alerts-tab-id-3">{alertRepData.title}</h4>
                </div>
                <div className='alert-details-card-body' id="sensor-alerts-tab-id-4">
                    <div className='alert-details-card-body-left' id="sensor-alerts-tab-id-5">
                        <div className='alert-info-col' id="sensor-alerts-tab-id-6">
                            <div className='info-data' id="sensor-alerts-tab-id-7">
                                <p className='data-label' id="sensor-alerts-tab-id-8">Selected Time Period</p>
                                <p className='data-value' id="sensor-alerts-tab-id-9">{" ("}{moment(startDate).format(format)}{") - ("}{moment(endDate).format(format)}{")"}</p>
                            </div>
                            <div className='info-data' id="sensor-alerts-tab-id-10">
                                <p className='data-label' id="sensor-alerts-tab-id-11">Number of Alerts</p>
                                <p className='data-value' id="sensor-alerts-tab-id-12">
                                    {
                                        alertRepData.alertCount > 0 ? <Link to={{
                                            pathname: `/alertsReport/${encodeURIComponent(sensorID)}/${JSON.stringify(moment(startDate).format("YYYY-MM-DD"))}/${JSON.stringify(moment(endDate).format("YYYY-MM-DD"))}/${site}/${alertRepData.category}`
                                        }} className="link">
                                            {alertRepData.alertCount}</Link>
                                            :
                                            alertRepData.alertCount
                                    }
                                </p>
                            </div>
                            <div className='info-data' id="sensor-alerts-tab-id-13">
                                <p className='data-label' id="sensor-alerts-tab-id-14">Duration of Longest Alert</p>
                                <p className='data-value' id="sensor-alerts-tab-id-15">{
                                    alertRepData.longestDuration > 0 ?
                                        <Link to={{
                                            pathname: `/alertsReport/${encodeURIComponent(sensorID)}/${JSON.stringify(startDate)}/${JSON.stringify(endDate)}/${site}/${alertRepData.category}/${alertRepData.longestDuration}`
                                        }} className="link">
                                            {alertRepData.longestDuration} {" "}days</Link>
                                        :
                                        alertRepData.longestDuration + " days"}</p>
                            </div>
                        </div>
                        <div className='alert-info-col' id="sensor-alerts-tab-id-16">
                            <div className='info-data' id="sensor-alerts-tab-id-17">
                                <p className='data-label' id="sensor-alerts-tab-id-18">Total Duration of Alerts</p>
                                <p className='data-value' id="sensor-alerts-tab-id-19">{alertRepData.cumulativeDuration}{" "}days</p>
                            </div>
                            <div className='info-data' id="sensor-alerts-tab-id-20">
                                <p className='data-label' id="sensor-alerts-tab-id-21">  Wall Thickness Loss</p>
                                <p className='data-value' id="sensor-alerts-tab-id-22">  {" "}
                                    {units
                                        ? round(
                                            0.0393700787 * alertRepData.wallThicknessLoss,
                                            3
                                        )
                                        : round(
                                            alertRepData.wallThicknessLoss,
                                            3
                                        )
                                    }{" "}{mmOrInch(units)}</p>
                            </div>
                            <div className='info-data' id="sensor-alerts-tab-id-23">
                                <p className='data-label' id="sensor-alerts-tab-id-24">Highest One Day Corrosion Rate</p>
                                <p className='data-value' id="sensor-alerts-tab-id-25">
                                    {units
                                        ? round(
                                            39.3700787402 * alertRepData.maxCorrosionRate,
                                            3
                                        )
                                        : round(
                                            alertRepData.maxCorrosionRate,
                                            3
                                        )}{" "}{mmOrMiles(units)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='alert-details-card-body-right' id="sensor-alerts-tab-id-26">
                        <div className='speedometer-container' id="sensor-alerts-tab-id-27">
                            <ReactSpeedometer
                                id="sensor-alerts-tab-id-28"
                                maxSegmentLabels={0}
                                segments={3}
                                height={150}
                                width={250}
                                currentValueText={'' + displayedAlertavgCR}
                                value={speedmeterValue}
                                needleHeightRatio={0.7}
                                ringWidth={50}
                                segmentColors={["#197647", "#FBCF09", "#D93638"]}
                                needleColor="#343434"
                            />
                            <div className='speedometer-info' id="sensor-alerts-tab-id-29">
                                <p className='data-label' id="sensor-alerts-tab-id-30">{alertRepData.statusTitle}</p>
                                <Tooltip id="sensor-alerts-tab-id-31" className='tooltip' placement='bottom' overlay={<div id="sensor-alerts-tab-id-32" className='tooltip-content'>{helpContents.speedometer}</div>} trigger={
                                    <Button id="sensor-alerts-tab-id-33" variant='transparent' size='large' iconOnly icon={<InfoCircle id="sensor-alerts-tab-id-34" />} />
                                } />
                            </div>
                        </div>
                    </div>
                </div>
            </Card>)
        } else {
            return null;
        }
    }) : loadingScreen;

    const showAlertData = <div className='alerts-tab-conatiner' id="sensor-alerts-tab-id-35">
        <div className='alerts-tab-header' id="sensor-alerts-tab-id-36">

            <div className='alerts-tab-header-actions' id="sensor-alerts-tab-id-43">
                <div className="alerts-tab-start-wrapper" id="sensor-alerts-tab-id-44">
                    <p className="data-label" id="sensor-alerts-tab-id-45">Start Date</p>
                    <SingleDatePicker
                        id="sensor-alerts-tab-id-46"
                        generateConfig={momentGenerateConfig}
                        config="custom"
                        format="DD/MM/yyyy"
                        allowClear={false}
                        value={!inValidStartDate && startDate ? startDate : inValidStartDate ? inValidStartDate : null}
                        onChange={(date) => {
                            setStartErrorText(null)
                            setInValidStartDate(null)
                            if (date.isBefore(endDate)) {
                                handleDateChange(date, startDate, setStartDate, "DD/MM/yyyy")
                            }
                            else if (date.isAfter(endDate)) {
                                setStartErrorText("Start date cannot be after end date")
                                setInValidStartDate(date)
                            }
                        }
                        }
                    />
                    <p className="data-label error-label" id="sensor-alerts-tab-id-47">{startErrorText}</p>
                    {!startErrorText && <p className="data-label hidden-label">Hidden p</p>}
                </div>
                <div className="alerts-tab-end-wrapper" id="sensor-alerts-tab-id-48">
                    <p className="data-label" id="sensor-alerts-tab-id-49">End Date</p>
                    <SingleDatePicker
                        id="sensor-alerts-tab-id-50"
                        generateConfig={momentGenerateConfig}
                        config="custom"
                        format="DD/MM/yyyy"
                        value={!inValidEndDate && endDate ? endDate : inValidEndDate ? inValidEndDate : null}
                        onChange={(date) => {
                            setEndErrorText(null)
                            setInValidEndDate(null)
                            if (date.isAfter(startDate)) {
                                handleDateChange(date, endDate, setEndDate, "DD/MM/yyyy")
                            }
                            else if (date.isBefore(startDate)) {
                                setEndErrorText("End date cannot be before start date")
                                setInValidEndDate(date)
                            }
                        }
                        }
                        allowClear={false} />
                    <p className="data-label error-label" id="sensor-alerts-tab-id-51">{endErrorText}</p>
                    {!endErrorText && <p className="data-label hidden-label">Hidden p</p>}
                </div>
                <div className='alerts-tab-slider-wrapper' id="sensor-alerts-tab-id-52">
                    <div className='alert-threshold-label' id="sensor-alerts-tab-id-53">
                        <p className="data-label" id="sensor-alerts-tab-id-54">Alert Threshold</p>
                        {/* <Tooltip id="sensor-alerts-tab-id-55" placement='bottom' className='tooltip' overlay={<div id="sensor-alerts-tab-id-56" className='tooltip-content'>{helpContents.alertThreshold}</div>} trigger={
                            <Button id="sensor-alerts-tab-id-57" variant='transparent' size='xsmall' iconOnly icon={<InfoCircle id="sensor-alerts-tab-id-58" />} />
                        } /> */}
                    </div>
                    <div>
                        {alertThreshold}
                    </div>
                    {/* <Slider min={0}
                        max={units ? 39.37 : 1}
                        marks={
                            { 0: "0", [units ? 39.37 : 1]: units ? "39.37" : "1" }
                        }
                        step={units ? 0.1 : 0.01}
                        value={alertThreshold}
                        onChange={(value) => setAlertThershold(parseFloat(value))}
                        id="sensor-alerts-tab-id-59"
                        disabled={true}
                    /> */}
                </div>
                {/* <Button onClick={() => handleUpdateThreshold()}> Update Threshold</Button> */}
                <Tooltip id="sensor-alerts-tab-id-39" placement='bottom' className='tooltip' overlay={<div id="sensor-alerts-tab-id-40" className='tooltip-content'>{helpContents.alertReport}</div>} trigger={
                    <Button id="sensor-alerts-tab-id-41" variant='transparent' size='large' iconOnly icon={<InfoCircle id="sensor-alerts-tab-id-42" />} />
                } />
            </div>
        </div>
        <br />
        {loading && loadingScreen}
        {!loading && <div className='alerts-tab-body' id="sensor-alerts-tab-id-60">
            {alertPanels}
        </div>}

    </div>

    return alertRepData ? showAlertData : loadingScreen;
}

export default SensorAlertsTab